async function fetchCartData() {
  try {
    const response = await fetch('/cart.js', { cache: 'no-store' });
    if (!response.ok) throw new Error('Cart fetch failed');
    return await response.json();
  } catch (err) {
    console.error('Error fetching cart data:', err);
    return null;
  }
}

async function checkCartAndUpdateDraftOrder() {
  const cartData = await fetchCartData();
  console.log(cartData, "< cartData DO delete");
  
  if (!cartData || !cartData.items || cartData.items.length === 0) {
    // Cart is empty → set draftOrderId to null
    localStorage.setItem('draftOrderId', 'null');
    window.draftOrderId = null;
    console.log('Cart is empty → draftOrderId set to null');


    document.querySelectorAll('.cart-item').forEach(row => row.remove());

    // Hide footer section
    const footer = document.querySelector('#main-cart-footer');
    const footer_content = document.querySelector('.cart__contents');
    if (footer) footer.style.display = 'none';
    if (footer_content) footer_content.style.display = 'none';

    // Show empty state
    const emptyState = document.querySelector('.cart__warnings');
    if (emptyState) emptyState.style.display = 'block';

  } else {
    console.log('Cart has items → draftOrderId remains unchanged');
  }
}

function startCartWatcher(interval = 2000) {
  let lastItemCount = null;
  setInterval(async () => {
    const cartData = await fetchCartData();
    if (!cartData) return;
    const currentItemCount = cartData.items.length;

    if (currentItemCount !== lastItemCount) {
      console.log(`Cart changed → ${currentItemCount} items`);
      await checkCartAndUpdateDraftOrder();
      lastItemCount = currentItemCount;
    }
  }, interval);
}

document.addEventListener('DOMContentLoaded', () => {
  checkCartAndUpdateDraftOrder();
  startCartWatcher();
});
